import {
	SET_KPI_DASHBOARD_CONTAINER
} from "../../actions/DashboardDesigner/actionContants";

const kpiDashboardContainer = (state = [], action) => {
	switch (action.type) {
		case SET_KPI_DASHBOARD_CONTAINER:
			return action.data;
		
		default:
			return state;
	}
};

export default kpiDashboardContainer;
